import React from "react";
import { Spinner } from "../Utils/Loaders";

export default function Loader({ children, isLoading, loadingText, small = false }) {
    if (!isLoading)
        return children;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {small && <Spinner height={40} width={40} marginBottom={0} marginTop={0} /> || <Spinner />}
            {loadingText && <strong style={{ fontSize: '1.5rem' }}>{loadingText}</strong>}
        </div>)
}